export const GlobalSearchModuleName = {
    Account: "accounts",
    Lead: "leads",
    Contact: "contacts",
    Estimate: "estimate",
    Invoice: "invoice",
    Opportunity: "opportunities",
    Warehouse: "locations",
    Product: "products",
    Purchases: "purchaseorder",
    Case: "cases",
    // SavedSearch: "saved-searches",
    SerialNo:"serialno",
    BillOrder:"billorder",
    SalesOrder:"salesorder",
    Territory: "territory",
    InventoryTransfer:"inventorytransfer",
    InventoryAdjustment:"inventoryadjustment",
    CreditMemo:"creditmemo",
    CustomerRma:"customerrma"
};
